import { autoinject, bindable, bindingMode, customElement, observable, factory } from 'aurelia-framework';
import { BaseCustomElement } from 'Common/BaseCustomElement';
import { SaveProgress } from 'Code/Extension/Progress';
import { DataService } from 'DataAccessLayer/Services/DataService';
import { Toastr } from 'Code/Extension/Toastr';
import { I18N } from 'aurelia-i18n';
import { computedFrom } from 'aurelia-binding';
import { Config } from 'Config';
import { GuidHelper } from 'Code/Helpers/GuidHelper';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { StringHelper } from 'Code/Helpers/StringHelper';

@autoinject
export class PictureBoxBaseCustomElement extends BaseCustomElement {

    @bindable({ defaultBindingMode: bindingMode.toView }) columnName: string = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) entityName: string = null;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) value: number = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) editable: boolean = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) tabIndexId: number = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) onChange: any = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) configJson: any = null;

    protected selectFile: string = null;
    protected files: Array<File> = null;
    protected dataService: DataService = null;
    protected i18n: I18N = null;
    protected pictureDrawMode: boolean = false;
    protected guidDraw: string = GuidHelper.NewGuid();
    private offlineFullPicture: string = null;
    private offlinePreviewPicture: string = null;
    private offlineDrawPicture: string = null;
    private offlinePreviewDrawPicture: string = null;

    constructor(dataService: DataService, i18n: I18N) {
        super();
        this.dataService = dataService;
        this.i18n = i18n;
    }

    private NewGuidDraw() {
        this.guidDraw = GuidHelper.NewGuid();
        this.GetPictureOffline();
    }

    async bind() {
        await this.GetPictureOffline();
    }

    async GetPictureOffline() {
        if (!this.isOnline && ObjectHelper.ObjectIs(this.value) && this.value > 0) {
            this.offlineFullPicture = await this.dataService.GetPicturesFullOffline(this.value);
            this.offlinePreviewPicture = await this.dataService.GetPicturesPreviewOffline(this.value);
            this.offlineDrawPicture = await this.dataService.GetDrawPicturesFullOffline(this.value);
            this.offlinePreviewDrawPicture = await this.dataService.GetDrawPicturesPreviewOffline(this.value);
        }
        console.log(7777777, this.offlineDrawPicture)
    }

    async attached() {
        //console.log(555555, 'PictureTemplate', this.value, this.columnName);
        if (ObjectHelper.IsNullOrUndefined(this.value)
            && ObjectHelper.ObjectIs(this.configJson) && ObjectHelper.ObjectIs(this.configJson.FieldConfig)
            && ObjectHelper.ObjectIs(this.configJson.FieldConfig.PictureDrawMode) && this.configJson.FieldConfig.PictureDrawMode == true
            && ObjectHelper.ObjectIs(this.configJson.FieldConfig.PictureTemplate) && ObjectHelper.ObjectIs(this.configJson.FieldConfig.PictureTemplate.FromPictureId) && this.configJson.FieldConfig.PictureTemplate.FromPictureId > 0
        ) {

            const url1: string = `${this.apiUrl}/GetFullPicture/${this.configJson.FieldConfig.PictureTemplate.FromPictureId}?userToken=${JSON.parse(localStorage[Config.TokenName()] || null).Token}`
            fetch(url1)
                .then(res => res.blob()) // Gets the response and returns it as a blob
                .then(blob => {
                    if (ObjectHelper.ObjectIs(blob)) {
                        //console.log(555555, 'blob', blob);
                        this.files = [];
                        const file1 = new File([blob], 'image.jpeg', {
                            type: blob.type,
                        });
                        this.files.push(file1);
                        this.ImportFile();
                    }
                });
        }

        if (this.ObjectIs(this.configJson) && this.ObjectIs(this.configJson.FieldConfig)
            && this.ObjectIs(this.configJson.FieldConfig.PictureDrawMode) && this.configJson.FieldConfig.PictureDrawMode) {
            this.pictureDrawMode = true;
        }
        this.CreateDroppable();
        ($(`#${this.guid}inputFile`) as any).change((e) => {
            this.TriggerCallback(e);
        });
    }

    public OpenInputDialog() {
        console.log(111, 'OpenInputDialog');
        ($(`#${this.guid}inputFile`) as any).trigger("click");
    }

    private async ImportFile() {
        console.log(111, 'ImportFile');
        SaveProgress.Show();
        var formData = new FormData();
        var count = this.files.length;
        for (var index = 0; index < count; index++) {
            var file: File = this.files[index];
            formData.append(file.name, file);
        }
        this.value = await this.dataService.UploadPicture(formData, file.name);
        if (this.value > 0) {
            await this.GetPictureOffline();
        } else {
            Toastr.Error('Toastr.Oooops', 'Import se nezdařil');
        }
        this.files = null;
        SaveProgress.Hide();
    }

    public async CreateDroppable() {
        //console.log(111, 'CreateDroppable');
        if (this.editable == false) {
            return;
        }
        let element = document.getElementById(`${this.guid}droppable-container`);
        element.addEventListener('dragover', async (e) => {
            e.preventDefault();
            e.stopPropagation();
            element.classList.add('dragover');
            element.classList.add('green');
        });
        element.addEventListener('dragleave', async (e) => {
            e.preventDefault();
            e.stopPropagation();
            element.classList.remove('dragover');
            element.classList.remove('green');
        });
        element.addEventListener('drop', async (e) => {
            e.preventDefault();
            e.stopPropagation();
            element.classList.remove('dragover');
            element.classList.remove('green');
            await this.TriggerCallback(e);
        });
    }

    public async TriggerCallback(e) {

        let files;
        if (e.dataTransfer) {
            files = e.dataTransfer.files;
        }
        else if (e.target) {
            files = e.target.files;
        }
        console.log(111, 'TriggerCallback', files);
        this.files = files;
        this.ImportFile();
    }

    protected showPreviewNormal: boolean = false;
    protected OpenPreviewNormalModal() {
        if (StringHelper.StringIs(this.value)) {
            this.showPreviewNormal = true;
            ($(`#${this.guid}-PreviewNormal`) as any).modal('show');
        }
    }

    protected ClosePreviewNormalModal() {
        ($(`#${this.guid}-PreviewNormal`) as any).modal('hide');
        this.showPreviewNormal = false;
    }

    protected showPreviewDraw: boolean = false;
    protected OpenPreviewDrawModal() {
        if (StringHelper.StringIs(this.value) && this.pictureDrawMode) {
            this.showPreviewDraw = true;
            ($(`#${this.guid}-PreviewDraw`) as any).modal('show');
        }
    }

    protected ClosePreviewDrawModal() {
        ($(`#${this.guid}-PreviewDraw`) as any).modal('hide');
        this.showPreviewDraw = false;
    }

    protected DownloadNormal() {
        if (this.value > 0) {
            var anchor = document.createElement('a');
            anchor.download = 'picture.jpg';
            if (this.isOnline) {
                anchor.href = `${this.apiUrl}/GetFullPicture/${this.value}?userToken=${this.userToken}&random=${((new Date()).getTime())}`;
            }
            else {
                anchor.href = this.offlineFullPicture;
            }
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        }
    }

    protected DownloadDraw() {
        if (this.value > 0) {
            var anchor = document.createElement('a');
            anchor.download = 'picture.jpg';
            if (this.isOnline) {
                anchor.href = `${this.apiUrl}/GetDrawPicture/${this.value}?userToken=${this.userToken}&random=${((new Date()).getTime())}`;
            }
            else {
                anchor.href = this.offlineDrawPicture;
            }
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        }
    }

    protected ClearFull() {
        this.value = null;
        this.Change();
    }

    protected async ClearDraw() {
        await this.dataService.ClearDrawPicture(this.value);
        this.NewGuidDraw();
        await this.GetPictureOffline();
    }

    protected Change() {
        if (ObjectHelper.ObjectIs(this.onChange)) {
            this.onChange();
        }
    }

    protected stage: any = null;
    protected layerPicture: any = null;
    protected layerDraw: any = null;
    protected canvasDraw: any = null;
    protected context: any = null;
    protected showDraw: boolean = false;
    protected OpenDrawModal() {
        this.NewGuidDraw();
        if (StringHelper.StringIs(this.value)) {
            let thisParent = this;
            this.showDraw = true;
            ($(`#${this.guid}-Draw`) as any).modal('show');

            var width = window.innerWidth;
            var height = window.innerHeight;

            // first we need Konva core things: stage and layer
            this.stage = new Konva.Stage({
                container: `#${this.guid}-DrawContainer`,
                width: width,
                height: height
            });
            this.stage.crossOrigin = 'Anonymous';

            this.layerPicture = new Konva.Layer();
            this.stage.add(this.layerPicture);
            var canvasPicture = document.createElement('canvas');
            //canvasPicture.crossOrigin = 'Anonymous';
            canvasPicture.width = this.stage.width();
            canvasPicture.height = this.stage.height();
            var imagePicture = new Konva.Image({
                image: canvasPicture,
                x: 0,
                y: 0
            });
            this.layerPicture.add(imagePicture);

            this.layerDraw = new Konva.Layer();
            this.stage.add(this.layerDraw);
            this.canvasDraw = document.createElement('canvas');
            this.canvasDraw.width = this.stage.width();
            this.canvasDraw.height = this.stage.height();
            var imageDraw = new Konva.Image({
                image: this.canvasDraw,
                x: 0,
                y: 0
            });
            this.layerDraw.add(imageDraw);


            this.stage.draw();

            // Good. Now we need to get access to context element
            this.context = this.canvasDraw.getContext('2d');
            this.context.strokeStyle = '#ff0000';
            this.context.lineJoin = 'round';
            this.context.lineWidth = 3;

            var isPaint = false;
            var lastPointerPosition;

            // now we need to bind some events
            // we need to start drawing on mousedown
            // and stop drawing on mouseup
            imageDraw.on('mousedown touchstart', function () {
                isPaint = true;
                lastPointerPosition = thisParent.stage.getPointerPosition();
            });

            // will it be better to listen move/end events on the window?

            this.stage.on('mouseup touchend', function () {
                isPaint = false;
            });

            // and core function - drawing
            this.stage.on('mousemove touchmove', function () {
                if (!isPaint) {
                    return;
                }

                thisParent.context.globalCompositeOperation = 'source-over';
                thisParent.context.beginPath();

                var localPos = {
                    x: lastPointerPosition.x - imageDraw.x(),
                    y: lastPointerPosition.y - imageDraw.y()
                };
                thisParent.context.moveTo(localPos.x, localPos.y);
                var pos = thisParent.stage.getPointerPosition();
                localPos = {
                    x: pos.x - imageDraw.x(),
                    y: pos.y - imageDraw.y()
                };
                thisParent.context.lineTo(localPos.x, localPos.y);
                thisParent.context.closePath();
                thisParent.context.stroke();

                lastPointerPosition = pos;
                thisParent.layerDraw.batchDraw();
            });

            var imgObj = new Image();
            imgObj.onload = function () {
                //console.log(11, imgObj.width, imgObj.height, width, height);

                imagePicture.image(imgObj);  // give the image to the cannvas image object.

                // since this is a dynamic image upload we want to resize the canvas image object to get 
                // a pleasing effect.
                var padding = 0;
                var w = imgObj.width;
                var h = imgObj.height;

                // get the aperture we need to fit by taking padding of the stage size.
                var targetW = thisParent.stage.getWidth() - (2 * padding);
                var targetH = thisParent.stage.getHeight() - (2 * padding);

                // compute the ratios of image dimensions to aperture dimensions 
                var widthFit = targetW / w;
                var heightFit = targetH / h;

                // compute a scale for best fit and apply it
                var scale = (widthFit > heightFit) ? heightFit : widthFit;
                //console.log(222, scale)

                w = w * scale;
                h = h * scale;

                thisParent.stage.width(w);
                thisParent.stage.height(h);

                imagePicture.size({
                    width: w,
                    height: h
                });

                // Finally position the canvas image object centered.
                //centreRectShape(uploadedImage); 

                //imagePicture.x( ( stage.getWidth() - imagePicture.getWidth() ) / 2);
                //imagePicture.y( ( stage.getHeight() - imagePicture.getHeight() ) / 2);

                thisParent.layerPicture.draw();

                //var planetsContext = layerPicture.getContext();
                //planetsContext.drawImage(imageObj, 0, 0);
            };
            //console.log(11, this.downloadPicture);
            imgObj.crossOrigin = 'Anonymous';
            if (this.isOnline) {
                imgObj.src = `${this.apiUrl}/GetDrawOrFullPicture/${this.value}?userToken=${this.userToken}&random=` + this.guidDraw;
            }
            else {
                if (ObjectHelper.ObjectIs(this.offlineDrawPicture)) {
                    imgObj.src = this.offlineDrawPicture;
                } else {
                    imgObj.src = this.offlineFullPicture;
                }
            }


            //imgObj.src = 'o1.jpg';

        }
        this.NewGuidDraw();
    }

    protected async SaveAndCloseDrawModal() {
        this.NewGuidDraw();
        var dataurl = this.stage.toDataURL({ mimeType: 'image/jpeg', quality: 0.9 });

        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        let file: File = new File([u8arr], 'image.jpg', { type: mime });

        SaveProgress.Show();
        var formData = new FormData();
        formData.append(file.name, file);
        const done: boolean = await this.dataService.UploadDrawPicture(formData, this.value);
        if (!done) {
            Toastr.Error('Toastr.Oooops', 'Import se nezdařil');
        }
        this.files = null;
        this.NewGuidDraw();
        SaveProgress.Hide();
        await this.GetPictureOffline();
        this.CloseDrawModal();

    }

    protected CloseDrawModal() {
        ($(`#${this.guid}-Draw`) as any).modal('hide');
        this.showDraw = false;
    }

    protected DrawClear() {
        this.context.clearRect(0, 0, this.canvasDraw.width, this.canvasDraw.height);
        this.layerDraw.batchDraw();
    }
}